import React, { useEffect, useState } from 'react';
import { Table, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import PaginationControls from '../components/PaginationControls';
import { getUser } from '../utils/auth';

const DELETE_ALLOWED_ROLES = ['admin', 'masteradmin'];

function QualificationList() {
  const [qualifications, setQualifications] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const navigate = useNavigate();
  const canDelete = DELETE_ALLOWED_ROLES.includes(getUser()?.role);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    fetch(`${API_BASE_URL}/qualifications/get_qualifications.php?page=${page}`, {
      credentials: 'include'
    })
      .then(response => response.json())
      .then(data => {
        setQualifications(data.items || []);
        setTotalPages(data.total_pages || 1);
        setTotalRows(data.total_rows || 0);
      })
      .catch(error => console.error('Error fetching qualifications:', error));
  }, [page]);

  const handleEdit = (id) => {
    navigate(`/config/add-qualification/${id}`);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      icon: 'warning',
      text: 'Are you sure you want to delete this qualification/role?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });
    if (!result.isConfirmed) return;

    fetch(`${API_BASE_URL}/qualifications/delete_qualification.php?id=${id}`, {
      method: 'DELETE',
      credentials: 'include',
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setQualifications(qualifications.filter(q => q.id !== id));
        } else {
          Swal.fire({ icon: 'warning', text: data.message || 'Failed to delete qualification/role' });
        }
      })
      .catch(error => console.error('Error deleting qualification:', error));
  };

  return (
    <div>
      <h2>List of Qualifications/Roles</h2>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {qualifications.length > 0 ? (
            qualifications.map(qualification => (
              <tr key={qualification.id}>
                <td>{qualification.name}</td>
                <td>{qualification.type}</td>
                <td>
                  <Button
                    variant="warning"
                    className="me-2"
                    onClick={() => handleEdit(qualification.id)}
                  >
                    Edit
                  </Button>
                  {canDelete && (
                    <Button
                      variant="danger"
                      onClick={() => handleDelete(qualification.id)}
                    >
                      Delete
                    </Button>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="text-center">
                No qualifications/roles available.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <PaginationControls page={page} totalPages={totalPages} totalRows={totalRows} onPageChange={setPage} />
      <Link to="/config/add-qualification">
        <Button variant="primary" className="m-1">Add New Qualification/Role</Button>
      </Link>
    </div>
  );
}

export default QualificationList;
